module.exports = __webpack_public_path__ + "img/shield.e9e8a23e.svg";